import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService } from '../utils/config-service';

@Injectable({ providedIn: 'root' })
export class FinancialReportService {

  constructor(private http: HttpClient) {}

  get(params: { from?: string; to?: string } = {}) {
    let url = ConfigService.toApiUrl('financial-report');
    const qs: string[] = [];
    if (params.from) qs.push(`from=${params.from}`);
    if (params.to) qs.push(`to=${params.to}`);
    if (qs.length) url += '?' + qs.join('&');
    return this.http.get<any>(url, ConfigService.addAction('list'));
  }
}
